import { INTEGRATIONS_ROOT } from 'environment';

angular.module('app.resources').factory('Pandadoc', ($resource) =>
    $resource(`${INTEGRATIONS_ROOT}/pandadoc`, {}, {
        getTemplates: {
            method: 'GET',
            url: `${INTEGRATIONS_ROOT}/pandadoc/templates`,
            isArray: true,
        },
        getTemplateFolders: {
            method: 'GET',
            url: `${INTEGRATIONS_ROOT}/pandadoc/template_folders`,
            isArray: true,
        }
    })
);



// WEBPACK FOOTER //
// ./resources/pandadoc.js